import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const routes = [
  { path: "/login", component: () => import("@/views/Login.vue") },
  {
    path: "/users",
    component: () => import("@/views/Users.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/clients",
    component: () => import("@/views/Clients.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/services",
    component: () => import("@/views/Services.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/queue",
    component: () => import("@/views/Queue.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/attention",
    component: () => import("@/views/Attention.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/attentionlist",
    component: () => import("@/views/AttentionList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/analytics",
    component: () => import("@/views/Analytics.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/queue-history",
    component: () => import("@/views/QueueHistory.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({ history: createWebHistory(), routes });

// Guardia de Navegación Global
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  
  // Lista de páginas públicas que no requieren autenticación
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  
  // Verificamos si el usuario está autenticado (si existe un token en el store)
  const isAuthenticated = !!authStore.token;

  if (authRequired && !isAuthenticated) {
    // Si la ruta requiere autenticación y el usuario NO está logueado,
    // lo redirigimos a la página de login.
    return next('/login');
  }
  // if (to.path === "/dashboard" && isAuthenticated && authStore.user.id === 2) {
  // Si el usuario es el cliente (id=2) y no está intentando ir a /queue, lo forzamos a ir ahí.
  if (isAuthenticated && authStore.user.id === 2 && to.path !== '/queue') {
    return next("/queue");
  }

  if (to.path === '/login' && isAuthenticated) {
    // Si el usuario YA está logueado y trata de ir a la página de login,
    // lo redirigimos al dashboard.
    return next('/dashboard');
  }

  // Si todo está en orden, permitimos que continúe a la ruta solicitada.
  next();
});
// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore();
//   if (to.meta.requiresAuth && !authStore.token) {
//     next("/login");
//   } else {
//     next();
//   }
// });

export default router;
